
export default function(node) {
  if (!node) {
    return document;
  }

  if (node.nodeType === Node.DOCUMENT_NODE) {
    return node;
  }

  return node.ownerDocument || document;
}



// WEBPACK FOOTER //
// ./node_modules/ally.js/src/util/get-document.js